module.exports = __webpack_public_path__ + "img/coinmarketcap.563a67de.png";